import { Outlet } from 'react-router-dom';
import NavigationBar from './NavigationBar';
import Footer from './Footer';

/**
 * Layout component
 * Main layout wrapper that includes navigation and footer
 * Uses React Router's Outlet to render child routes
 */
const Layout: React.FC = () => {
  return (
    <div className='entry-container'>
      <NavigationBar />
      <div className='content-wrapper'>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
